import React from "react";
import { useSelector } from "react-redux";
import { Spinner } from "UI";
import moment from "moment";
import { translate as getTranslate } from "@haldor/ui";
var SelectionDisplay = function SelectionDisplay(props) {
  if (props.start == null || props.end == null) {
    return null;
  }
  var translate = getTranslate(useSelector(function (state) {
    return state.Languages.translations;
  }));
  if (props.view == "month") {
    return /*#__PURE__*/React.createElement("div", {
      className: "df aic selection-display"
    }, /*#__PURE__*/React.createElement("h3", {
      style: {
        marginBottom: ".75rem",
        marginTop: 0
      }
    }, moment(props.start).format("MMMM")), props.isLoading ? /*#__PURE__*/React.createElement(Spinner, null) : null);
  }
  if (moment(props.end).diff(moment(props.start), "days") > 1) {
    return /*#__PURE__*/React.createElement("div", {
      className: "df aic selection-display"
    }, /*#__PURE__*/React.createElement("h3", {
      style: {
        marginBottom: ".75rem"
      }
    }, translate("Week"), " ", moment(props.start).week()), props.isLoading ? /*#__PURE__*/React.createElement(Spinner, null) : null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "df aic selection-display"
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      marginBottom: ".75rem"
    }
  }, moment(props.start).format("dddd D MMMM").capitalize()), props.isLoading ? /*#__PURE__*/React.createElement(Spinner, null) : null);
};
export default SelectionDisplay;